var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview__iframe-wrapper"},[(!_vm.loaded)?_c('div',{staticClass:"preview__loading"}):_vm._e(),_vm._v(" "),_c('iframe',{staticClass:"preview__iframe",class:{ 'preview--hidden': !_vm.loaded },attrs:{"src":`https://docs.google.com/gview?url=${_vm.encodedUrl}&embedded=true`},on:{"load":function($event){_vm.loaded = true}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }